"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/domains/auth/AuthProvider";
import { queryClient } from "@/lib/react-query";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
